module.exports = __webpack_public_path__ + "42a7b4f8e19aa2741ff04c6d807e13b8.pdf";